import * as React from 'react'
import { cn } from '../helpers/index.js'
import { Slot } from '@radix-ui/react-slot'
import type { ComponentPropsWithout, RemovedProps } from '../helpers/component-props.js'

type SkeletonElement = React.ElementRef<'span'>

interface SkeletonProps extends ComponentPropsWithout<'span', RemovedProps> {
  /** 是否正在加载 , 默认是true*/
  loading?: boolean
}

/**
 * Skeleton - 骨架屏
 *
 * @description 用于内容加载时显示占位符的骨架屏组件，提供流畅的加载体验
 */
const Skeleton = React.forwardRef<SkeletonElement, SkeletonProps>((props, forwardedRef) => {
  const { children, className, loading = true, ...skeletonProps } = props

  if (!loading) return children
  const Tag = React.isValidElement(children) ? Slot : 'span'

  return (
    <Tag
      ref={forwardedRef}
      className={cn(
        `bg-skeleton !pointer-events-none animate-pulse !cursor-default !select-none !border-none !bg-none !decoration-clone 
        !bg-clip-border !text-transparent !shadow-none !outline-none before:!invisible after:!invisible
        empty:block data-[inline-skeleton=true]:leading-[0] [&>*]:!invisible
        `,
        className
      )}
      data-inline-skeleton={React.isValidElement(children) ? undefined : true}
      tabIndex={-1}
      {...skeletonProps}
    >
      {children}
    </Tag>
  )
})

Skeleton.displayName = 'Skeleton'

export default Skeleton
export type { SkeletonProps }
